/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Passkey_Secret_RevokedInputs */

const es_co2_error_passkey_secret_revoked = /** @type {(inputs: Error_Passkey_Secret_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta llave fue revocada.`)
};

/**

* @param {Error_Passkey_Secret_RevokedInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_passkey_secret_revoked = /** @type {((inputs?: Error_Passkey_Secret_RevokedInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Passkey_Secret_RevokedInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_passkey_secret_revoked(inputs)
});